<template>
     
    <div>
        <div class="text-left mb-3">
            <h3 class="mb-3">{{$t('cal_comm_title')}}</h3>
            <p>{{$t('cal_comm_title_txt')}}</p>
        </div>
        <div class="verticallyTab mt-5">
			<p v-if="message != ''" style="color:red">{{message}}</p>
            <div class="bottomTab">
                <div class="stepForm-contact mt-5">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field form-control" @change="getSymbol(segm)" v-model="segm" v-validate="'required'" name="segm" :class="{ 'is-invalid': submitted && errors.has('segm'), 'active' : segm != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                  <!--   <option value=""></option> -->
                                    <option value="forex">{{$t('cal_comm_forex')}}</option>
                                    <option value="commd">{{$t('cal_comm_commodities')}}</option>
                                    <option value="indic">{{$t('cal_comm_indices')}}</option>
                                    <!--<option>Crypto</option>-->
                                </select>
                                <label class="float-label">{{$t('cal_comm_Asset_Class')}}</label>
								 <p class="error" v-if="submitted" v-for="error in errors.collect('segm')">{{$t('cal_comm_Field_req')}}</p>  
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field form-control" v-model="basecurreny" v-validate="'required'" name="basecurreny" :class="{ 'is-invalid': submitted && errors.has('basecurreny'), 'active' : basecurreny != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                    <!-- <option value=""></option> -->
                                    <option value="USD">{{$t('cal_comm_USD')}}</option>
                                    <option value="GBP">{{$t('cal_comm_GBP')}}</option>
                                    <option value="AUD">{{$t('cal_comm_AUD')}}</option>
                                    <option value="EUR">{{$t('cal_comm_EUR')}}</option>
                                </select>
                                <label class="float-label">{{$t('cal_comm_accBaseCurr')}}</label>
								<p class="error" v-if="submitted" v-for="error in errors.collect('basecurreny')">{{$t('cal_comm_Field_req')}}</p> 
                            </div>
                        </div>
                        <!-- {{ isins }}=={{ this.selectedSeg }} -->
                        <div class="col-12 col-md-6">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field form-control" v-model="selectedSymbol"  v-validate="'required'" name="selectedSymbol" :class="{ 'is-invalid': submitted && errors.has('selectedSymbol'), 'active' : selectedSymbol != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                   <!--  <option value=""></option> -->
                                   <option v-for="spreads in isins" :value="spreads">{{spreads}}</option>
                                </select>
                                <label class="float-label">{{$t('cal_comm_Symbol')}}</label>
								<p class="error" v-if="submitted" v-for="error in errors.collect('selectedSymbol')">{{$t('cal_comm_Field_req')}}</p> 
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group field-wrapper">
                                <input type="text" v-model="tradesize" class="float-field form-control"  v-validate="{ required: true,decimal:5}" name="tradesize" :class="{ 'is-invalid': submitted && errors.has('tradesize') }">
                                <label class="float-label" style="text-transform: none !important;">{{$t('cal_comm_trade_size_lot')}}</label>
								<p class="error" v-if="submitted" v-for="error in errors.collect('tradesize')">{{$t('cal_comm_Field_req')}}</p> 
                            </div>
                        </div>
                        <!-- <div class="col-12 col-md-6">
                            <div class="form-group field-wrapper">
                                <input placeholder=" " type="email" name="username" class="float-field">
                                <label class="float-label">Current Conversion Price</label>
                            </div>
                        </div> -->
                        <div class="col-12 col-md-12">
                            <div class="form-group field-wrapper">
                                <a href="#" class="common_btn" v-on:click.prevent="calculateComm()">{{$t('cal_comm_now')}}</a>
                                <p class="mt-3">{{$t('cal_comm_Comm_roundT')}}: {{basecurreny}} {{commission.toFixed(2)}} </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
        
</template>
<script>
    // import { ProviderCacheMixins } from '@/plugins/vue-provider-cache/mixin'
    import { fxViewMixins } from '@/plugins/fxView' 
    export default {
        name: 'Commision',
        mixins: [fxViewMixins],
        // mixins: [ProviderCacheMixins],
        data() {
            return {
                "segm": '',
                "tradesize": 0,
                "selectedSymbol":"",
                "selectedSeg":"",
                "commission": 0,
                "basecurreny":'USD',
				submitted : false,
				message : ''
            }
        },
        created(){
            this.getSymbol('forex')
        },
        computed:{
            isins(){
                switch(this.selectedSeg){
                    case 'commd':
                        return Object.keys(this.get_Commodity_All);
                        break;
                    case 'forex':
                        return Object.keys(this.get_currencies);
                        break;
                    case 'indic':
                        return Object.keys(this.get_Indices_all);
                        break;
                    default:
                        return [];
                        break;
                }
            }
        },
        methods:{
            getSymbol(getSymbolFor){
                /*if(getSymbolFor == 'commd'){
                    this.isins = Object.keys(this.get_Commodity_All)
                }if(getSymbolFor == 'forex'){
                    this.isins = Object.keys(this.get_currencies)
                }if(getSymbolFor == 'indic'){
                    this.isins = Object.keys(this.get_Indices_all)
                }*/
                this.selectedSeg = getSymbolFor
                  // this.isins = getData
            },
            calculateComm(){
				const _that = this
                this.submitted = true;
				this.message = ''
                this.$validator.validate().then(valid => {
                    if (valid) {
						let symb = ""
						
                        symb = _that.all_currencies_price[_that.selectedSymbol]

                        if(parseFloat(_that.tradesize) >= parseFloat(symb.other.Min_Trade_Size)){
							let contractSize = symb.other.Contract_Size
							contractSize = contractSize.match(/(\d+)/)[0]; 

                            
                            //: ( Lot * contract size* (first currency to base currency) *2) /100,000

                            // that.commission = (that.tradesizeX  contractSizeX Index price  (currencyPrice * 2)) /100000

							let currencyPrice = ''

                            if(symb.other.type.toUpperCase() == 'INDICIES'){

                                
                                currencyPrice = _that.currencyConverstionSecond(_that.selectedSymbol)

                                //console.log("currency price", currencyPrice)

                                //console.log("contractSize", contractSize)

                                //console.log("tradesize size", _that.tradesize)

                                //console.log("symb.A", symb.A)



                                _that.commission = (_that.tradesize * contractSize * symb.A * (currencyPrice * 2)) /100000
                            }
                            else{
                                currencyPrice = _that.currencyConverstion(_that.selectedSymbol)

                                //console.log("currency price", currencyPrice)

                                //console.log("contractSize price", contractSize)

                                //console.log("tradesize size", _that.tradesize)

                                 _that.commission = (_that.tradesize * contractSize * (currencyPrice * 2)) /100000

                            }

                            // if(_that.basecurreny != 'USD'){
                            //    _that.commission = _that.commission * _that.currencyConverstionSecond("USD"+_that.basecurreny)
                            // }

                           
							//USDTOBASE
						}else{
							_that.message = "Minimum trade size should be "+ parseFloat(symb.other.Min_Trade_Size)
						}
					}
				})
                //selected symbol
            },
            currencyConverstion(selectedSymbol){
                //all_currencies_price will get all currecies prices

                 let secondCurrency = selectedSymbol.substring(0, 3);

                if(secondCurrency == this.basecurreny){
                    return 1
                }

                else if(this.all_currencies_price[secondCurrency+this.basecurreny]){
                    return this.all_currencies_price[secondCurrency+this.basecurreny].A
                } 
 
                else if(this.all_currencies_price[this.basecurreny+secondCurrency]){
                    return 1/this.all_currencies_price[this.basecurreny+secondCurrency].A
                } 
                else{

                    let secontoUSD = 0
                    let accBasetoUSD = 0
                    if(this.all_currencies_price[secondCurrency+"USD"]){
                        secontoUSD = this.all_currencies_price[secondCurrency+"USD"].A
                    } 
                    else if(this.all_currencies_price["USD"+secondCurrency]){
                        secontoUSD = 1/this.all_currencies_price["USD"+secondCurrency].A
                    } 

                    if(this.basecurreny=="USD"){
                        accBasetoUSD = 1
                    }
                    else if(this.all_currencies_price[this.basecurreny+"USD"]){
                        accBasetoUSD = 1/this.all_currencies_price[this.basecurreny+"USD"].A
                    } 
                    else if(this.all_currencies_price["USD"+this.basecurreny]){
                        accBasetoUSD = this.all_currencies_price["USD"+this.basecurreny].A
                    } 

                    return accBasetoUSD*secontoUSD
                }
                return 1
            },
            currencyConverstionSecond(selectedSymbol){
                //all_currencies_price will get all currecies prices

                let secondCurrency = selectedSymbol.substring(3, 6);

                if(secondCurrency == this.basecurreny){
                    return 1
                }

                else if(this.all_currencies_price[secondCurrency+this.basecurreny]){
                    return this.all_currencies_price[secondCurrency+this.basecurreny].A
                } 
 
                else if(this.all_currencies_price[this.basecurreny+secondCurrency]){
                    return 1/this.all_currencies_price[this.basecurreny+secondCurrency].A
                } 
                else{

                    let secontoUSD = 0
                    let accBasetoUSD = 0
                    if(this.all_currencies_price[secondCurrency+"USD"]){
                        secontoUSD = this.all_currencies_price[secondCurrency+"USD"].A
                    } 
                    else if(this.all_currencies_price["USD"+secondCurrency]){
                        secontoUSD = 1/this.all_currencies_price["USD"+secondCurrency].A
                    } 

                    if(this.basecurreny=="USD"){
                        accBasetoUSD = 1
                    }
                    else if(this.all_currencies_price[this.basecurreny+"USD"]){
                        accBasetoUSD = 1/this.all_currencies_price[this.basecurreny+"USD"].A
                    } 
                    else if(this.all_currencies_price["USD"+this.basecurreny]){
                        accBasetoUSD = this.all_currencies_price["USD"+this.basecurreny].A
                    } 

                    return accBasetoUSD*secontoUSD
                }
                return 1
            },

        },
        
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/fxView/shared/calculators/commission.vue